import { useMemo } from "react";

import { useRoute } from "@/hooks/useRoute";

export function useNavigate() {
  const { f7router } = useRoute();
  return useMemo(() => f7router.navigate.bind(f7router), [f7router]);
}
